import { render } from "./CreateAction.vue?vue&type=template&id=a73081f6&scoped=true"
import script from "./CreateAction.vue?vue&type=script&lang=js"
export * from "./CreateAction.vue?vue&type=script&lang=js"

import "./CreateAction.vue?vue&type=style&index=0&id=a73081f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a73081f6"]])

export default __exports__